import React, { useEffect, useState } from 'react';
import { Button, Card, Empty, Form, Input, InputNumber, message, Spin, Table } from 'antd';
import { Link } from 'react-router-dom';
import profileService from '../../../services/profileService';
import formService from '../../../services/formService';
import localStorageService from '../../../services/localStorageService';

const text = {
  title: '\u7528\u6237\u4fe1\u606f',
  username: '\u7528\u6237\u540d',
  realName: '\u59d3\u540d',
  password: '\u5bc6\u7801',
  changePassword: '\u66f4\u6539\u5bc6\u7801',
  newPassword: '\u65b0\u5bc6\u7801',
  email: '\u90ae\u7bb1',
  phone: '\u7535\u8bdd',
  address: '\u5730\u5740',
  abn: 'ABN',
  salary: '\u5de5\u8d44',
  salaryReport: '\u5de5\u8d44\u62a5\u544a',
  hourlyFee: '\u8bfe\u65f6\u8d39',
  settledSalary: '\u5df2\u7ed3\u7b97\u5de5\u8d44',
  commission: '\u4e1a\u7ee9',
  wage: '\u5de5\u8d44',
  project: '\u4e0a\u8bfe\u7c7b\u578b',
  amount: '\u5de5\u8d44',
  count: '\u6b21\u6570',
  settlement: '\u7ed3\u7b97',
  studentName: '\u540d\u5b57',
  courseTypeDisplayName: '\u8bfe\u7a0b\u7c7b\u522b\u540d\u79f0',
  actualReceipt: '\u5b9e\u9645\u6536\u6b3e',
  performanceCommission: '\u4e1a\u7ee9\u63d0\u6210',
  referralCommissionAmount: '\u63a8\u8350\u4eba\u63d0\u6210',
  performanceIncome: '\u4e1a\u7ee9\u6536\u5165',
  hourlyTotal: '\u8bfe\u65f6\u8d39\u603b\u8ba1',
  total: '\u603b\u8ba1',
  period: '\u65f6\u95f4',
  sentAt: '\u53d1\u9001\u65f6\u95f4',
  referralCommission: '\u63a8\u8350\u63d0\u6210',
  edit: '\u66f4\u6539',
  save: '\u4fdd\u5b58',
  cancel: '\u53d6\u6d88',
  success: '\u4fe1\u606f\u5df2\u66f4\u65b0',
  failed: '\u4fdd\u5b58\u5931\u8d25',
  backProfile: '\u8fd4\u56de\u7528\u6237\u4fe1\u606f',
  loadFailed: '\u8bfb\u53d6\u7528\u6237\u4fe1\u606f\u5931\u8d25',
};

const totalText = (value) => Number(value || 0).toFixed(1);

const settledHourlyColumns = [
  { title: text.project, dataIndex: 'name', key: 'name' },
  { title: text.amount, dataIndex: 'amount', key: 'amount' },
  { title: text.count, dataIndex: 'count', key: 'count' },
  { title: text.settlement, dataIndex: 'settlement', key: 'settlement' },
];

const settledCommissionColumns = [
  { title: text.studentName, dataIndex: 'studentName', key: 'studentName', width: '15%' },
  {
    title: text.courseTypeDisplayName,
    dataIndex: 'courseTypeDisplayName',
    key: 'courseTypeDisplayName',
    width: '15%',
  },
  { title: text.actualReceipt, dataIndex: 'total_aud', key: 'total_aud', width: '15%' },
  {
    title: text.performanceCommission,
    dataIndex: 'performanceCommissionAmount',
    key: 'performanceCommissionAmount',
    width: '15%',
  },
  {
    title: text.referralCommissionAmount,
    dataIndex: 'referralCommissionAmount',
    key: 'referralCommissionAmount',
    width: '15%',
  },
  {
    title: text.performanceIncome,
    dataIndex: 'performanceIncome',
    key: 'performanceIncome',
    width: '25%',
  },
];

const settledWageColumns = [
  { title: text.hourlyTotal, dataIndex: 'hourlyTotal', key: 'hourlyTotal' },
  {
    title: text.performanceCommission,
    dataIndex: 'performanceCommissionTotal',
    key: 'performanceCommissionTotal',
  },
  { title: text.total, dataIndex: 'total', key: 'total' },
];

const ProfileSalaryReport = () => {
  const [loading, setLoading] = useState(true);
  const [salarySettlements, setSalarySettlements] = useState([]);

  useEffect(() => {
    profileService
      .getProfile()
      .then((profileRes) => {
        const user = profileRes.data || {};
        setSalarySettlements((user.salarySettlements || []).slice(0, 1));
      })
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingTop: 40,
      }}
    >
      <Card
        title={text.salaryReport}
        style={{ width: 900, marginTop: 20 }}
        extra={<Link to='/profile'>{text.backProfile}</Link>}
      >
        <Spin spinning={loading}>
          {salarySettlements.length ? (
            salarySettlements.map((settlement, index) => (
              <div
                key={settlement.key || index}
                style={{
                  borderBottom:
                    index === salarySettlements.length - 1 ? 'none' : '1px solid #f0f0f0',
                  paddingBottom: 20,
                  marginBottom: 20,
                }}
              >
                <div style={{ marginBottom: 12 }}>
                  {text.period}: {settlement.from || '-'} - {settlement.to || '-'}
                  <span style={{ marginLeft: 24 }}>
                    {text.sentAt}: {settlement.createdAt ? settlement.createdAt.slice(0, 10) : '-'}
                  </span>
                </div>
                <div style={{ fontWeight: 600, margin: '12px 0 8px' }}>{text.hourlyFee}</div>
                <Table
                  size='small'
                  dataSource={settlement.salaryRows || []}
                  columns={settledHourlyColumns}
                  pagination={false}
                  summary={(pageData) => {
                    const total = pageData.reduce(
                      (sum, row) => sum + Number(row.settlement || 0),
                      0
                    );
                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>{text.total}</Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3}>{totalText(total)}</Table.Summary.Cell>
                      </Table.Summary.Row>
                    );
                  }}
                />
                <div style={{ fontWeight: 600, margin: '20px 0 8px' }}>{text.commission}</div>
                <Table
                  size='small'
                  dataSource={settlement.commissionRows || []}
                  columns={settledCommissionColumns}
                  pagination={false}
                  tableLayout='fixed'
                  summary={(pageData) => {
                    const receiptTotal = pageData.reduce(
                      (sum, row) => sum + Number(row.total_aud || 0),
                      0
                    );
                    const performanceTotal = pageData.reduce(
                      (sum, row) => sum + Number(row.performanceCommissionAmount || 0),
                      0
                    );
                    const referralTotal = pageData.reduce(
                      (sum, row) => sum + Number(row.referralCommissionAmount || 0),
                      0
                    );
                    const incomeTotal = pageData.reduce(
                      (sum, row) => sum + Number(row.performanceIncome || 0),
                      0
                    );
                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>{text.total}</Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2}>{totalText(receiptTotal)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>{totalText(performanceTotal)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={4}>{totalText(referralTotal)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={5}>{totalText(incomeTotal)}</Table.Summary.Cell>
                      </Table.Summary.Row>
                    );
                  }}
                />
                <div style={{ fontWeight: 600, margin: '20px 0 8px' }}>{text.wage}</div>
                <Table
                  size='small'
                  dataSource={settlement.wageRows || []}
                  columns={settledWageColumns}
                  pagination={false}
                />
              </div>
            ))
          ) : (
            <Empty />
          )}
        </Spin>
      </Card>
    </div>
  );
};

const ProfileSalarySetting = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [courseTypes, setCourseTypes] = useState([]);

  useEffect(() => {
    Promise.all([
      profileService.getProfile(),
      formService.queryCourseType(),
    ])
      .then(([profileRes, courseTypeRes]) => {
        const user = profileRes.data || {};
        setCourseTypes(courseTypeRes.data || []);
        form.setFieldsValue({
          courseCommissions: {
            referralCommission: 10,
            ...(user.courseCommissions || {}),
          },
        });
      })
      .catch(() => message.error(text.loadFailed))
      .finally(() => setLoading(false));
  }, [form]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card
        title={text.salary}
        style={{ width: 460 }}
        extra={<Link to='/profile'>{text.backProfile}</Link>}
      >
        <Spin spinning={loading}>
          <Form
            layout='horizontal'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            form={form}
            labelAlign='left'
          >
            <div style={{ fontWeight: 600, marginBottom: 16 }}>{text.hourlyFee}</div>
            {courseTypes.map((courseType) => (
              <Form.Item
                key={courseType.type}
                label={courseType.name}
                name={['courseCommissions', courseType.type]}
              >
                <InputNumber disabled precision={2} style={{ width: 160 }} />
              </Form.Item>
            ))}
            <Form.Item
              label={text.performanceCommission}
              name={['courseCommissions', 'courseCommission']}
              style={{ marginTop: 24 }}
            >
              <InputNumber
                disabled
                precision={2}
                formatter={(value) => (value || value === 0 ? `${value}%` : '')}
                parser={(value) => value.replace('%', '')}
                style={{ width: 160 }}
              />
            </Form.Item>
            <Form.Item
              label={text.referralCommission}
              name={['courseCommissions', 'referralCommission']}
            >
              <InputNumber
                disabled
                precision={2}
                formatter={(value) => (value || value === 0 ? `${value}%` : '')}
                parser={(value) => value.replace('%', '')}
                style={{ width: 160 }}
              />
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </div>
  );
};

const Profile = ({ match }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [profileData, setProfileData] = useState({});

  useEffect(() => {
    profileService
      .getProfile()
      .then((res) => {
        const { _id, name, cnname, email, phone, address, abn, role } = res.data;
        const values = { _id, name, cnname, email, phone, address, abn, role };
        setProfileData(values);
        form.setFieldsValue(values);
      })
      .catch(() => {
        localStorageService.removeJWT();
        message.error('\u8bfb\u53d6\u7528\u6237\u4fe1\u606f\u5931\u8d25\uff0c\u8bf7\u91cd\u65b0\u767b\u5f55');
        window.location.href = '/';
      })
      .finally(() => setLoading(false));
  }, [form]);

  const handleSave = async (values) => {
    if (!editing) {
      return;
    }
    const payload = { ...values };
    if (!payload.password) {
      delete payload.password;
    }
    setSaving(true);
    try {
      await profileService.updateProfile(payload);
      message.success(text.success);
      setProfileData({ ...payload, password: undefined });
      form.setFieldsValue({ password: '' });
      setEditing(false);
    } catch (err) {
      message.error(text.failed);
    } finally {
      setSaving(false);
    }
  };

  if (match && match.url.endsWith('/salary')) {
    return <ProfileSalaryReport />;
  }

  if (match && match.url.endsWith('/salary-setting')) {
    return <ProfileSalarySetting />;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <Card title={text.title} style={{ width: 420 }}>
        <Spin spinning={loading}>
          <Form
            layout='vertical'
            form={form}
            onFinish={handleSave}
            onSubmitCapture={(event) => {
              if (!editing) {
                event.preventDefault();
                event.stopPropagation();
              }
            }}
          >
            <Form.Item
              label={text.username}
              name='name'
              rules={[{ required: true, message: '\u8bf7\u8f93\u5165\u7528\u6237\u540d' }]}
            >
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item
              label={text.realName}
              name='cnname'
              rules={[{ required: true, message: '\u8bf7\u8f93\u5165\u59d3\u540d' }]}
            >
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.email} name='email'>
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.phone} name='phone'>
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.address} name='address'>
              <Input disabled={!editing} />
            </Form.Item>
            <Form.Item label={text.abn} name='abn'>
              <Input disabled={!editing} />
            </Form.Item>
            {editing && (
              <>
                <div style={{ fontWeight: 500, margin: '20px 0 8px' }}>
                  {text.changePassword}
                </div>
                <Form.Item label={text.newPassword} name='password'>
                  <Input.Password placeholder='留空表示不修改密码' />
                </Form.Item>
              </>
            )}
          </Form>
          <div style={{ marginTop: 24 }}>
            {editing ? (
              <>
                <Button
                  type='primary'
                  htmlType='button'
                  loading={saving}
                  onClick={() => form.submit()}
                >
                  {text.save}
                </Button>
                <Button
                  htmlType='button'
                  style={{ marginLeft: 12 }}
                  onClick={() => {
                    form.setFieldsValue({ ...profileData, password: '' });
                    setEditing(false);
                  }}
                >
                  {text.cancel}
                </Button>
              </>
            ) : (
              <Button
                type='primary'
                htmlType='button'
                onClick={() => setEditing(true)}
              >
                {text.edit}
              </Button>
            )}
            {Number(profileData.role) === 2 && (
              <Link to='/profile/salary-setting'>
                <Button htmlType='button' style={{ marginLeft: 12 }}>
                  {text.salary}
                </Button>
              </Link>
            )}
          </div>
        </Spin>
      </Card>
    </div>
  );
};

export default Profile;
